import React, { lazy, Suspense, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const DynamicProjectLoader = () => {
  const { projectId } = useParams();
  const [selectedProject, setSelectedProject] = useState(projectId);

  useEffect(() => {
    setSelectedProject(projectId); // Update selected project when projectId changes
  }, [projectId]);

  const ProjectComponent = React.useMemo(() => {
    try {
      return selectedProject ? lazy(() => import(`./${selectedProject}/content`)) : null;
    } catch (error) {
      console.error(`Error loading project component for ${selectedProject}:`, error);
      return null; // Return null if the module cannot be found
    }
  }, [selectedProject]);

  return (
    <Suspense fallback={<div>loading...</div>}>
      {ProjectComponent ? <ProjectComponent /> : <div className='self-start'>Select a project to view</div>}
    </Suspense>
  );
}

export default DynamicProjectLoader;
